module.exports = "app.controller('PlannerController', function ($stateParams, $http, $scope, $rootScope, $state, $location, Init, utils, $q, $uibModal) {});"